module.exports = __webpack_public_path__ + "static/img/zczg-title.f9935c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zczg-title.jpg
// module id = 0/rp
// module chunks = 1